import { render, staticRenderFns } from "./FixedFooter.vue?vue&type=template&id=316eb6a0&scoped=true&lang=pug&"
import script from "./FixedFooter.vue?vue&type=script&lang=js&"
export * from "./FixedFooter.vue?vue&type=script&lang=js&"
import style0 from "./FixedFooter.vue?vue&type=style&index=0&id=316eb6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316eb6a0",
  null
  
)

export default component.exports